import { Verified } from '@mui/icons-material';
import { Typography } from '@mui/material';
import { isNewListing } from '../../../utils/constants';
import { parseJSON } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'next-i18next';

interface Props {
  createdAt: Date | string;
  size?: 'md' | 'sm';
}

export const NewListingMark: FC<Props> = ({ createdAt, size = 'md' }) => {
  const { t } = useTranslation(['directory', 'common']);
  const date = typeof createdAt === 'string' ? parseJSON(createdAt) : createdAt;

  if (isNewListing(date)) {
    return (
      <Typography
        variant={size === 'md' ? 'body1' : 'caption'}
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5,
          color: '#040D62',
          fontWeight: 'bold',
        }}
      >
        <Verified sx={{ fontSize: size === 'md' ? '20px' : '18px' }} />
        {t('directory:company:newListing')}
      </Typography>
    );
  }

  return null;
};
